/* Casucci 2026 — pagina prodotto (<cs-product>). Vanilla, defer, nessuna dipendenza.
   Varianti, galleria, lightbox, guida taglie, add to cart (Casucci.addToCart), CTA sticky, ritiro, prezzo Omnibus.
   I prodotti consigliati sono una sezione a parte (cs-product-recommendations + cs-recs.js). */
(() => {
  if (customElements.get('cs-product')) return;

  const money = (c) => (window.Casucci && window.Casucci.money ? window.Casucci.money(c) : `€${(c / 100).toFixed(2).replace('.', ',')}`);
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const behavior = () => (reduceMotion() ? 'auto' : 'smooth');

  // Dialog nativi: apertura con focus gestito, chiusura su backdrop, focus restituito all'opener.
  const openDialog = (dialog, opener) => {
    if (!dialog || typeof dialog.showModal !== 'function') return;
    dialog.showModal();
    document.body.classList.add('cs-modal-open');
    const onClose = () => {
      document.body.classList.remove('cs-modal-open');
      opener && opener.focus({ preventScroll: true });
      dialog.removeEventListener('close', onClose);
    };
    dialog.addEventListener('close', onClose);
  };
  document.addEventListener('click', (e) => {
    if (e.target instanceof HTMLDialogElement && (e.target.classList.contains('cs-dialog') || e.target.classList.contains('cs-lightbox'))) e.target.close();
  });

  class CsProduct extends HTMLElement {
    connectedCallback() {
      const json = this.querySelector('[data-cs-variants]');
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.form = document.getElementById(this.dataset.form);
      this.sizeIndex = Number(this.dataset.sizeIndex);
      this.needSize = this.hasAttribute('data-need-size');
      this.waNumber = this.dataset.wa;
      this.atc = this.querySelector('[data-cs-atc]');
      this.atcLabel = this.querySelector('[data-cs-atc-label]');
      this.atcText = (this.atc && this.atc.dataset.label) || 'Aggiungi al carrello';
      this.fieldsets = [...this.querySelectorAll('[data-cs-option]')];
      this.sizeChosen = !this.needSize;

      this.variant = this.currentVariant() || this.variants.find((v) => v.available) || this.variants[0];

      this.addEventListener('change', (e) => {
        if (e.target.matches('.cs-opt__input')) this.onOptionChange(e.target);
      });
      this.addEventListener('click', (e) => this.onClick(e));
      if (this.form) this.form.addEventListener('submit', (e) => this.onSubmit(e));

      // Pagamento rapido: se manca la taglia, intercetta prima che parta il checkout con la variante sbagliata.
      const dyn = this.querySelector('[data-cs-dyn]');
      if (dyn) {
        dyn.addEventListener('click', (e) => {
          if (!this.sizeChosen) {
            e.preventDefault();
            e.stopPropagation();
            this.promptSize();
          }
        }, true);
      }

      this.updateOptionStates();
      this.updateWaLinks();
      this.initGallery();
      this.initSticky();
      if (this.querySelector('[data-cs-model]') && window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {} }]);
      }
    }

    disconnectedCallback() {
      this.io && this.io.disconnect();
      this.stickyIo && this.stickyIo.disconnect();
      document.body.classList.remove('cs-has-sticky');
    }

    /* ---------- Varianti ---------- */
    selectedOptions() {
      return this.fieldsets.map((fs) => {
        const c = fs.querySelector('.cs-opt__input:checked');
        return c ? c.value : null;
      });
    }

    currentVariant() {
      const sel = this.selectedOptions();
      if (!sel.length) return this.variants[0];
      if (sel.some((o) => o === null)) {
        // Taglia non ancora scelta: variante "di riferimento" per prezzo/media (stesso colore, prima disponibile).
        const match = (v) => sel.every((o, i) => o === null || v.options[i] === o);
        return this.variants.find((v) => match(v) && v.available) || this.variants.find(match);
      }
      return this.variants.find((v) => v.options.every((o, i) => o === sel[i]));
    }

    onOptionChange(input) {
      const fs = input.closest('[data-cs-option]');
      const label = fs.querySelector('[data-cs-option-label]');
      if (label) label.textContent = input.value;
      if (fs.hasAttribute('data-cs-size')) {
        this.sizeChosen = true;
        const err = fs.querySelector('[data-cs-size-error]');
        if (err) err.hidden = true;
        fs.classList.remove('is-error');
      }
      let v = this.currentVariant();
      if (!v && !fs.hasAttribute('data-cs-size') && this.sizeIndex >= 0) {
        // Il nuovo colore non esiste nella taglia scelta: tieni il colore, azzera la taglia.
        const sizeFs = this.fieldsets[this.sizeIndex];
        const checked = sizeFs && sizeFs.querySelector('.cs-opt__input:checked');
        if (checked) checked.checked = false;
        this.sizeChosen = false;
        const sl = sizeFs && sizeFs.querySelector('[data-cs-option-label]');
        if (sl) sl.innerHTML = '<span class="cs-muted">seleziona</span>';
        v = this.currentVariant();
      }
      this.variant = v;
      this.updateOptionStates();
      this.render(true);
    }

    updateOptionStates() {
      const sel = this.selectedOptions();
      this.fieldsets.forEach((fs, i) => {
        fs.querySelectorAll('.cs-opt__input').forEach((input) => {
          const candidates = this.variants.filter((v) => v.options[i] === input.value && sel.every((o, j) => j === i || o === null || v.options[j] === o));
          const exists = candidates.length > 0;
          const available = candidates.some((v) => v.available);
          // Le combinazioni inesistenti si disabilitano solo per opzioni diverse dalla prima (il colore resta sempre cliccabile).
          input.disabled = !exists && i > 0;
          const lab = input.nextElementSibling;
          lab.classList.toggle('is-soldout', exists && !available);
          lab.classList.toggle('is-missing', !exists);
          const sr = lab.querySelector('[data-cs-soldout-sr]');
          if (sr) sr.textContent = !exists ? ' (non disponibile)' : !available ? ' (esaurito)' : '';
        });
      });
    }

    render(userAction) {
      const v = this.variant;
      if (!v) {
        this.setAtc('Non disponibile', true);
        return;
      }
      // id del form (select no-JS / hidden) + form rate
      this.querySelectorAll('[data-cs-id]').forEach((el) => (el.value = v.id));
      const inst = this.querySelector('[data-cs-inst-id]');
      if (inst) {
        inst.value = v.id;
        inst.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // Prezzo
      const cur = this.querySelector('[data-cs-price-current]');
      if (cur) {
        // Barrato solo se consentito da Omnibus (cmp calcolato in Liquid da cs-omnibus mode:'show_compare')
        const sale = v.cmp === undefined ? v.compare_at_price > v.price : !!v.cmp;
        cur.textContent = money(v.price);
        cur.classList.toggle('is-sale', sale);
        const was = this.querySelector('[data-cs-price-was]');
        const cmp = this.querySelector('[data-cs-price-compare]');
        const pct = this.querySelector('[data-cs-price-pct]');
        if (was) was.hidden = !sale;
        if (cmp) cmp.textContent = sale ? money(v.compare_at_price) : '';
        if (pct) {
          pct.hidden = !sale;
          if (sale) pct.textContent = `-${Math.round(((v.compare_at_price - v.price) * 100) / v.compare_at_price)}%`;
        }
      }

      // Omnibus: "Prezzo più basso negli ultimi 30 giorni" (centesimi per variante da cs-omnibus mode:'cents')
      const omni = this.querySelector('[data-cs-omni]');
      if (omni) {
        if (v.omni) {
          let out = omni.querySelector('[data-cs-omnibus-price]');
          if (!out) {
            const p = document.createElement('p');
            p.className = 'cs-omnibus';
            p.setAttribute('data-cs-omnibus', '');
            out = document.createElement('span');
            out.setAttribute('data-cs-omnibus-price', '');
            p.append(`${omni.dataset.label || ''} `, out);
            omni.replaceChildren(p);
          }
          out.textContent = money(v.omni);
          omni.hidden = false;
        } else {
          omni.hidden = true;
        }
      }

      // Disponibilità (scarsità solo se reale: "low" arriva da Liquid solo con inventario Shopify)
      const stock = this.querySelector('[data-cs-stock]');
      if (stock) {
        stock.hidden = !this.sizeChosen;
        stock.classList.toggle('is-low', !!v.low && v.available);
        stock.classList.toggle('is-out', !v.available);
        stock.textContent = !v.available
          ? `Esaurito${this.sizeIndex >= 0 ? ' in questa taglia' : ''}`
          : v.low
            ? v.low === 1 ? 'Ultimo pezzo disponibile' : `Ultimi ${v.low} pezzi disponibili`
            : 'Disponibile';
      }

      // Pulsante
      if (!this.sizeChosen) this.setAtc('Seleziona la taglia', false);
      else if (!v.available) this.setAtc('Esaurito', true);
      else this.setAtc(this.atcText, false);

      const soldout = this.querySelector('[data-cs-soldout]');
      if (soldout) soldout.hidden = !(this.sizeChosen && !v.available);
      const dyn = this.querySelector('[data-cs-dyn]');
      if (dyn) dyn.classList.toggle('is-hidden', !v.available);
      this.querySelector('[data-cs-msg]') && (this.querySelector('[data-cs-msg]').textContent = '');

      this.updateSticky();
      this.updateWaLinks();

      if (!userAction) return;
      // URL condivisibile solo con una selezione completa
      if (this.sizeChosen) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (v.media) this.showMedia(String(v.media), true);
      this.refreshPickup(v.id);
      document.dispatchEvent(new CustomEvent('cs:variant-change', { detail: { variant: v } }));
    }

    setAtc(text, disabled) {
      if (!this.atc) return;
      this.atc.disabled = disabled;
      if (this.atcLabel) this.atcLabel.textContent = text;
    }

    selectionText() {
      const parts = [];
      this.fieldsets.forEach((fs) => {
        const c = fs.querySelector('.cs-opt__input:checked');
        const name = fs.querySelector('legend').firstChild.textContent.replace(':', '').trim().toLowerCase();
        if (c) parts.push(`${name} ${c.value}`);
      });
      return parts.length ? ` (${parts.join(', ')})` : '';
    }

    updateWaLinks() {
      if (!this.waNumber) return;
      const sel = this.selectionText();
      this.querySelectorAll('[data-cs-wa-tpl]').forEach((a) => {
        a.href = `https://wa.me/${this.waNumber}?text=${encodeURIComponent(a.dataset.csWaTpl.replace('[sel]', sel))}`;
      });
    }

    promptSize() {
      const fs = this.querySelector('[data-cs-size]');
      if (!fs) return;
      const err = fs.querySelector('[data-cs-size-error]');
      if (err) err.hidden = false;
      fs.classList.add('is-error');
      fs.scrollIntoView({ behavior: behavior(), block: 'center' });
      const first = fs.querySelector('.cs-opt__input:not(:disabled)');
      first && setTimeout(() => first.focus({ preventScroll: true }), reduceMotion() ? 0 : 350);
    }

    /* ---------- Carrello ---------- */
    async onSubmit(e) {
      if (!this.sizeChosen) {
        e.preventDefault();
        this.promptSize();
        return;
      }
      if (!window.Casucci || !window.Casucci.addToCart) return; // fallback: submit normale a /cart/add
      e.preventDefault();
      const v = this.variant;
      if (!v || !v.available || this.atc.getAttribute('aria-busy') === 'true') return;
      const msg = this.querySelector('[data-cs-msg]');
      const qtyInput = document.querySelector(`input[name="quantity"][form="${this.form.id}"]`);
      const quantity = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
      this.atc.setAttribute('aria-busy', 'true');
      this.atc.classList.add('is-loading');
      this.setAtc('Aggiunta in corso…', false);
      if (msg) {
        msg.textContent = '';
        msg.classList.remove('is-error');
      }
      try {
        await window.Casucci.addToCart([{ id: v.id, quantity }], { open: true });
        this.setAtc('Aggiunto ✓', false);
        if (msg) msg.textContent = 'Articolo aggiunto al carrello.';
        setTimeout(() => this.render(false), 2000);
      } catch (err) {
        this.setAtc(this.atcText, false);
        if (msg) {
          msg.classList.add('is-error');
          msg.textContent = err && err.message ? err.message : 'Non è stato possibile aggiungere al carrello. Riprova.';
        }
      } finally {
        this.atc.removeAttribute('aria-busy');
        this.atc.classList.remove('is-loading');
      }
    }

    /* ---------- Click delegati ---------- */
    onClick(e) {
      const t = e.target;
      const zoom = t.closest('[data-cs-zoom]');
      if (zoom) return this.openLightbox(zoom.dataset.csZoom, zoom);
      const thumb = t.closest('[data-cs-thumb]');
      if (thumb) return this.showMedia(thumb.dataset.csThumb, false, true);
      const nav = t.closest('[data-cs-lb-nav]');
      if (nav) return this.lightboxStep(Number(nav.dataset.csLbNav));
      const open = t.closest('[data-cs-dialog-open]');
      if (open) return openDialog(document.getElementById(open.dataset.csDialogOpen), open);
      const q = t.closest('[data-cs-qty]');
      if (q) {
        const input = this.querySelector('[data-cs-qty-input]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(q.dataset.csQty));
        return;
      }
      if (t.closest('[data-cs-sticky-btn]')) {
        if (!this.sizeChosen) return this.promptSize();
        if (this.form) this.form.requestSubmit ? this.form.requestSubmit(this.atc) : this.atc.click();
        return;
      }
      const share = t.closest('[data-cs-share]');
      if (share) this.share(share);
    }

    async share(btn) {
      const out = this.querySelector('[data-cs-share-msg]');
      const data = { title: btn.dataset.title, url: btn.dataset.url };
      try {
        if (navigator.share) await navigator.share(data);
        else {
          await navigator.clipboard.writeText(data.url);
          if (out) out.textContent = 'Link copiato';
        }
      } catch (e) { /* condivisione annullata */ }
    }

    /* ---------- Galleria ---------- */
    initGallery() {
      this.gallery = this.querySelector('[data-cs-gallery]');
      const dots = this.querySelector('[data-cs-dots]');
      const counter = this.querySelector('[data-cs-counter]');
      if (!this.gallery || !dots) return;
      const items = () => [...this.gallery.children];
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          const i = items().indexOf(en.target);
          [...dots.children].forEach((d, j) => d.classList.toggle('is-active', j === i));
          if (counter) counter.textContent = `Immagine ${i + 1} di ${items().length}`;
          const id = en.target.dataset.mediaId;
          this.querySelectorAll('[data-cs-thumb]').forEach((b) => b.setAttribute('aria-current', String(b.dataset.csThumb === id)));
        });
      }, { root: null, threshold: 0.6 });
      items().forEach((el) => this.io.observe(el));
    }

    isCarousel() {
      return this.gallery && this.gallery.scrollWidth > this.gallery.clientWidth + 2;
    }

    // Variante: porta la sua media in prima posizione (desktop) o scorre il carosello (mobile).
    showMedia(id, fromVariant, fromThumb) {
      if (!this.gallery) return;
      const item = this.gallery.querySelector(`[data-media-id="${id}"]`);
      if (!item) return;
      if (this.isCarousel()) {
        this.gallery.scrollTo({ left: item.offsetLeft - this.gallery.offsetLeft, behavior: behavior() });
        return;
      }
      if (fromVariant) {
        this.gallery.prepend(item);
        const thumbs = this.querySelector('[data-cs-thumbs]');
        const th = thumbs && thumbs.querySelector(`li[data-media-id="${id}"]`);
        if (th) thumbs.prepend(th);
        const r = this.gallery.getBoundingClientRect();
        if (r.top < 0) this.gallery.scrollIntoView({ behavior: behavior(), block: 'start' });
      } else if (fromThumb) {
        item.scrollIntoView({ behavior: behavior(), block: 'start' });
      }
    }

    /* ---------- Lightbox ---------- */
    openLightbox(id, opener) {
      this.lb = this.lb || this.querySelector('[data-cs-lightbox]');
      if (!this.lb) return;
      openDialog(this.lb, opener);
      const track = this.lb.querySelector('[data-cs-lightbox-track]');
      const slide = track.querySelector(`[data-media-id="${id}"]`);
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
      const close = this.lb.querySelector('.cs-lightbox__close');
      close && close.focus();
      if (!this.lbBound) {
        this.lbBound = true;
        this.lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.lightboxStep(1);
          if (e.key === 'ArrowLeft') this.lightboxStep(-1);
        });
        // Desktop: click sull'immagine = zoom 2x (su mobile basta il pinch nativo)
        track.addEventListener('click', (e) => {
          const img = e.target.closest('img');
          if (!img || window.matchMedia('(pointer: coarse)').matches) return;
          const li = img.closest('li');
          const zoomed = li.classList.toggle('is-zoomed');
          if (zoomed) {
            const r = img.getBoundingClientRect();
            li.scrollTo({ left: ((e.clientX - r.left) / r.width) * li.scrollWidth - li.clientWidth / 2, top: ((e.clientY - r.top) / r.height) * li.scrollHeight - li.clientHeight / 2 });
          }
        });
      }
    }

    lightboxStep(dir) {
      const track = this.lb && this.lb.querySelector('[data-cs-lightbox-track]');
      if (!track) return;
      track.scrollBy({ left: dir * track.clientWidth, behavior: behavior() });
    }

    /* ---------- CTA sticky ---------- */
    initSticky() {
      this.sticky = this.querySelector('[data-cs-sticky]');
      if (!this.sticky || !this.atc) return;
      this.stickyIo = new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', show);
        this.sticky.toggleAttribute('inert', !show);
        this.sticky.setAttribute('aria-hidden', String(!show));
        const active = show && getComputedStyle(this.sticky).display !== 'none';
        document.body.classList.toggle('cs-has-sticky', active);
      });
      this.stickyIo.observe(this.atc);
      this.updateSticky();
    }

    updateSticky() {
      if (!this.sticky || !this.variant) return;
      const v = this.variant;
      const price = this.sticky.querySelector('[data-cs-sticky-price]');
      const sel = this.sticky.querySelector('[data-cs-sticky-sel]');
      const btn = this.sticky.querySelector('[data-cs-sticky-btn]');
      const img = this.sticky.querySelector('.cs-sticky__img img');
      if (price) price.textContent = money(v.price);
      if (sel) {
        const size = this.sizeIndex >= 0 && this.sizeChosen ? v.options[this.sizeIndex] : '';
        sel.textContent = size ? ` · Taglia ${size}` : this.fieldsets.length && this.sizeIndex < 0 ? ` · ${v.title}` : '';
      }
      if (img && v.image) {
        img.src = v.image;
        img.removeAttribute('srcset');
      }
      if (btn) {
        btn.disabled = this.sizeChosen && !v.available;
        btn.textContent = !this.sizeChosen ? 'Seleziona la taglia' : v.available ? 'Aggiungi' : 'Esaurito';
      }
    }

    /* ---------- Ritiro in negozio (Section Rendering API) ---------- */
    async refreshPickup(id) {
      const box = this.querySelector('[data-cs-pickup-native]');
      if (!box) return;
      try {
        const root = (window.routes && window.routes.root) || '';
        const html = await fetch(`${root}/variants/${id}/?section_id=cs-pickup-availability`).then((r) => (r.ok ? r.text() : ''));
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cs-pickup-native]');
        box.innerHTML = fresh ? fresh.innerHTML : '';
      } catch (e) { /* lascia il contenuto precedente */ }
    }
  }

  customElements.define('cs-product', CsProduct);
})();
